export default {
  meta: {
    title: '标签审核'
  }
};
